"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Parse = require("parse/node");
var ExportTaskStatus;
(function (ExportTaskStatus) {
    ExportTaskStatus["Requested"] = "REQUESTED";
    ExportTaskStatus["Exporting"] = "EXPORTING";
    ExportTaskStatus["Available"] = "AVAILABLE";
    ExportTaskStatus["Expired"] = "EXPIRED";
    ExportTaskStatus["Error"] = "ERROR"; // Exporter has finished with errors
})(ExportTaskStatus = exports.ExportTaskStatus || (exports.ExportTaskStatus = {}));
var ExportTaskType;
(function (ExportTaskType) {
    ExportTaskType["Order"] = "ORDER";
    ExportTaskType["Csr"] = "CSR";
    ExportTaskType["Customer"] = "CUSTOMER";
    ExportTaskType["Chat"] = "CHAT";
    ExportTaskType["HSM"] = "HSM";
    ExportTaskType["Message"] = "MESSAGE";
})(ExportTaskType = exports.ExportTaskType || (exports.ExportTaskType = {}));
class ExportTask extends Parse.Object {
    constructor(attributes) {
        super('ExportTask', attributes);
    }
    get retailer() { return this.get('retailer'); }
    set retailer(value) { this.set('retailer', value); }
    get requestedBy() { return this.get('requestedBy'); }
    set requestedBy(value) { this.set('requestedBy', value); }
    // When the reports builder started the job
    get startedAt() { return this.get('startedAt'); }
    set startedAt(value) { this.set('startedAt', value); }
    // When the reports builder finished the job
    get finishedAt() { return this.get('finishedAt'); }
    set finishedAt(value) { this.set('finishedAt', value); }
    get expiresAt() { return this.get('expiresAt'); }
    set expiresAt(value) { this.set('expiresAt', value); }
    get type() { return this.get('type'); }
    set type(value) { this.set('type', value); }
    get status() { return this.get('status'); }
    set status(value) { this.set('status', value); }
    get fileUrl() { return this.get('fileUrl'); }
    set fileUrl(value) { this.set('fileUrl', value); }
    // Only present with status === ExportTaskStatus.Error
    get errorMessage() { return this.get('errorMessage'); }
    set errorMessage(value) { this.set('errorMessage', value); }
}
exports.ExportTask = ExportTask;
Parse.Object.registerSubclass('ExportTask', ExportTask);
//# sourceMappingURL=ExportTask.js.map